export const workflowStepActionTrigger = {
    DISCARD: 'discard',
    TRANSITION: 'transition',
    REJECTION: 'rejection',
    APPROVAL: 'approval',
};
